
[
  {
    "id": "TG-M8P-L304-001",
    "module": "TijdGeld",
    "difficulty": 304,
    "question": "Inflatie is 2% per jaar. Iets kost nu € 100. Wat kost het over 2 jaar?",
    "options": ["€ 104,04", "€ 104,00", "€ 102,00", "€ 105,00"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "financieel",
    "subSkill": "rente",
    "familyId": "TG-INFLATIE",
    "explanation": "Jaar 1: 102. Jaar 2: 2% van 102 = 2,04. Totaal 104,04.",
    "distractorExplanations": { "1": "Geen rente op rente.", "2": "1 jaar.", "3": "Schattingsfout." }
  },
  {
    "id": "TG-M8P-L304-002",
    "module": "TijdGeld",
    "difficulty": 304,
    "question": "Hoeveel dagen leef je ongeveer als je 80 wordt?",
    "options": ["29.200", "25.000", "35.000", "80.000"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijd_omrekenen",
    "familyId": "TG-LEVENSDAGEN",
    "explanation": "80 x 365 = 29.200 (plus schrikkeldagen).",
    "distractorExplanations": { "1": "Te weinig.", "2": "Te veel.", "3": "Te veel." }
  },
  {
    "id": "TG-M8P-L304-003",
    "module": "TijdGeld",
    "difficulty": 304,
    "question": "Je koopt 1000 aandelen van € 5. Transactiekosten € 10 + 1%. Wat betaal je?",
    "options": ["€ 5.060", "€ 5.010", "€ 5.050", "€ 5.100"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "financieel",
    "subSkill": "btw",
    "familyId": "TG-AANDELEN-KOSTEN",
    "explanation": "5000 euro. 1% = 50. Plus 10 = 60. Totaal 5060.",
    "distractorExplanations": { "1": "Alleen vaste kosten.", "2": "Alleen procentuele kosten.", "3": "Schattingsfout." }
  },
  {
    "id": "TG-M8P-L304-004",
    "module": "TijdGeld",
    "difficulty": 304,
    "question": "Hoeveel uur is 10.000 seconden?",
    "options": ["2 uur 46 min 40 sec", "2 uur 30 min", "3 uur", "1 uur 40 min"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijd_omrekenen",
    "familyId": "TG-SEC-COMPLEX",
    "explanation": "10000 : 3600 = 2,77... 2 uur (7200). Rest 2800. 2800 : 60 = 46 min (2760). Rest 40 sec.",
    "distractorExplanations": { "1": "Schattingsfout.", "2": "Schattingsfout.", "3": "Schattingsfout." }
  },
  {
    "id": "TG-M8P-L304-005",
    "module": "TijdGeld",
    "difficulty": 304,
    "question": "Wat is het rendement als je € 200 winst maakt op een investering van € 4000?",
    "options": ["5%", "2%", "10%", "20%"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "financieel",
    "subSkill": "rente",
    "familyId": "TG-RENDEMENT",
    "explanation": "200 : 4000 = 2 : 40 = 1 : 20 = 5%.",
    "distractorExplanations": { "1": "Rekenfout.", "2": "Rekenfout.", "3": "Rekenfout." }
  }
]
